// useWorkspaceRoleLabel — the one localised label for the LIVE flat role
// vocabulary ("owner" | "member"), shared by Account and WorkspaceMembers so
// the two surfaces never drift. Sibling to `Admin/RoleBadge`'s
// `useRoleLabel`, which speaks the DORMANT admin/author/reviewer/viewer
// vocabulary — kept separate rather than widened, since the two vocabularies
// aren't interchangeable (see IDD 94442b9d).

export { useWorkspaceRoleLabel };

import { useLingui } from "@lingui/react/macro";
import type { WorkspaceRole } from "../../app/ports/iam.js";

// A Record over the closed `WorkspaceRole` union forces every role to have a
// label — a third live role stops this compiling until it's added here too.
const useWorkspaceRoleLabel = (): ((role: WorkspaceRole) => string) => {
    const { t } = useLingui();
    const labels: Record<WorkspaceRole, string> = {
        owner: t`Owner`,
        member: t`Member`,
    };
    return (role) => labels[role];
};
